export default {"src":"/_next/static/media/IE.c81ea85d.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};